module.exports = __webpack_public_path__ + "static/media/dwt-02.58104cd8.jpg";